import QCXCircularProgress from '../../../../../shared-components/progress/QCXCircularProgress';

export default function TextOrLoading({ children, loading, loadingSize = 20 }) {
  if (loading) {
    return (
      <div style={{ position: 'relative' }}>
        <div style={{ opacity: 0 }}>{children}</div>

        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <QCXCircularProgress color="inherit" size={loadingSize} />
        </div>
      </div>
    );
  }

  return children;
}
